import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserDrivesData } from "@services/api";
import { PendingTransactionsIcon, EarnedPointIcon } from '@util/svgicon';
import ScoreDrive from './ScoreDrive';
import UnScoreDrive from './UnScoreDrive';

const ScoreUnScoreDrive = () => {

    const [unscoredDriveData, setUnscoredDriveData] = useState([]);
    const [scoredDriveData, setScoredDriveData] = useState([]);
    const [filteredScoredData, setFilteredScoredData] = useState([]);
    const [allUsername, setAllUsername] = useState([]);
    const [selectedUsername, setSelectedUsername] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const ownerBotsList = useSelector((state) => state.appOwnerBots.bots);

    useEffect(() => {
        fetchData();
    }, [ownerBotsList]);

    useEffect(() => {
        if (selectedUsername) {
            const filteredUsernameScoredData = scoredDriveData.filter(item => item.username === selectedUsername);
            setFilteredScoredData(filteredUsernameScoredData); // Update the filtered data
        } else {
            setFilteredScoredData(scoredDriveData);
        }
    }, [selectedUsername, scoredDriveData]);

    const fetchData = async () => {
        setIsLoading(true);
        const allUnscoredData = [];
        const allScoredData = [];

        // for (const bot of ownerBotsList) {
            const unscoredData = await getUnscoredDriveHandler();
            const scoredData = await getScoredDriveHandler();

            allUnscoredData.push({ unscoredData });
            allScoredData.push({ scoredData });
        // }

        const unScoreData = allUnscoredData.reduce((acc, item) => acc.concat(item.unscoredData), []);
        const scoreData = allScoredData.reduce((acc, item) => acc.concat(item.scoredData), []);

        const sortByStartTimeUnScoreData = unScoreData.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));
        const sortByStartTimeScoreData = scoreData.sort((a, b) => new Date(b.start_time) - new Date(a.start_time));

        const sortlessthen3MinUnScoreData = sortByStartTimeUnScoreData.filter(item => {
            const startDateDuration = new Date(item?.start_time);
            const endDateDuration = new Date(item?.end_time);
            const differenceDurationMs = endDateDuration - startDateDuration;
            const differenceDurationSeconds = Math.floor(differenceDurationMs / 1000);
            const minutes = Math.floor(differenceDurationSeconds / 60);
            return minutes >= 3;
        });

        const sortlessthen3MinScoreData = sortByStartTimeScoreData.filter(item => {
            const startDateDuration = new Date(item?.start_time);
            const endDateDuration = new Date(item?.end_time);
            const differenceDurationMs = endDateDuration - startDateDuration;
            const differenceDurationSeconds = Math.floor(differenceDurationMs / 1000);
            const minutes = Math.floor(differenceDurationSeconds / 60);
            return minutes >= 3;
        });

        setUnscoredDriveData(sortlessthen3MinUnScoreData);
        setScoredDriveData(sortlessthen3MinScoreData);
        setFilteredScoredData(sortByStartTimeScoreData);
        const allUsernamefilter = [...new Set(sortByStartTimeScoreData.map(bot => bot.username))]
        setAllUsername(allUsernamefilter)
        setIsLoading(false);
    };

    const getUnscoredDriveHandler = async () => {
        const response = await getUserDrivesData('unscored');
        const unScore = await response?.epoch_rides?.length > 0 && response.epoch_rides.map(item => ({
            ...item,
            botName: item?.bot_name || ''
        }));
        return response && response?.epoch_rides?.length > 0 ? unScore : [];
    };

    const getScoredDriveHandler = async () => {
        const response = await getUserDrivesData('scored');
        const score = await response?.epoch_rides?.length > 0 && response.epoch_rides.map(item => ({
            ...item,
            botName: item?.bot_name || ''
        }));
        return response && response?.epoch_rides?.length > 0 ? score : [];
    };

    return (
        <div className='w-full flex flex-col items-start gap-[16px]'>
            <div className='w-full flex flex-col items-start gap-[24px]'>
                <div className='w-full flex flex-col items-start gap-[4px]'>
                    <div className='w-full flex pt-0 pr-[8px] pb-[8px] pl-0 justify-between items-center'>
                        <div className='flex items-center gap-[16px]'>
                            <div className='flex items-center gap-[8px]'>
                                <PendingTransactionsIcon />
                                <p className='text-[#282828] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Unscored Drives</p>
                            </div>
                        </div>
                    </div>
                    <table className='w-full flex flex-col py-[8px] justify-between items-center gap-[6px]'>
                        <thead className='w-full flex py-[8px] justify-between items-center rounded-[8px] bg-[#FAFAFA]'>
                            <tr className='w-full flex px-[16px] py-[8px] justify-between rounded-[8px]'>
                                <th className='w-[40%] text-start text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date/Time</th>
                                <th className='w-[60%] flex justify-end items-center'>
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Distance (km)</div>
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Multiplier</div>
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Qualified Miles</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className='w-full flex flex-col px-[16px] py-[8px] items-center gap-[24px] rounded-[8px] bg-[#FAFAFA]'>
                            {unscoredDriveData.length > 0 ?
                                unscoredDriveData.map((item, index) => (
                                    <UnScoreDrive
                                        item={item}
                                        index={index}
                                        key={index}
                                    />
                                ))
                                :
                                isLoading ?
                                    <Spinner size={25} />
                                    :
                                    <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>No unscored drives data found</p>
                            }
                        </tbody>
                    </table>
                </div>
                <div className='w-full flex flex-col items-start gap-[4px]'>
                    <div className='w-full flex pt-0 pr-[8px] pb-[8px] pl-0 justify-between items-center'>
                        <div className='w-full flex flex-col justify-between md:flex-row md:items-center gap-[16px]'>
                            <div className='flex items-center gap-[8px]'>
                                <EarnedPointIcon />
                                <p className='text-[#282828] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Scored Drives</p>
                            </div>
                            <div className='flex items-center gap-[8px]'>
                                <select
                                    className='p-[8px] rounded-[8px] bg-[#f3f3f3] border border-gray-300'
                                    value={selectedUsername}
                                    onChange={(e) => setSelectedUsername(e.target.value)}
                                >
                                    <option value=''>All Users</option>
                                    {allUsername.length > 0 && allUsername.map((username) => (
                                        <option key={username} value={username}>
                                            {username}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <table className='w-full flex flex-col py-[8px] justify-between items-center gap-[6px]'>
                        <thead className='w-full flex py-[8px] justify-between items-center rounded-[8px] bg-[#FAFAFA]'>
                            <tr className='w-full flex px-[16px] py-[8px] justify-between rounded-[8px]'>
                                <th className='w-[40%] text-start text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Date/Time</th>
                                <th className='w-[60%] flex justify-end items-center'>
                                    {/* <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Type</div> */}
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Distance (km)</div>
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Multiplier</div>
                                    <div className='w-[33%] text-[#727272] text-center text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Qualified Miles</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className='w-full flex flex-col px-[16px] py-[8px] items-center gap-[24px] rounded-[8px] bg-[#FAFAFA]'>
                            {filteredScoredData.length > 0 ?
                                filteredScoredData.map((item, index) => (
                                    <ScoreDrive
                                        item={item}
                                        index={index}
                                        key={index}
                                    />
                                ))
                                :
                                isLoading ?
                                    <Spinner size={25} />
                                    :
                                    <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>No scored drives data found</p>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

const Spinner = ({ size = 25, color = '#282828' }) => {
    return (
        <div
            className="spinnerRow"
            style={{
                width: size,
                height: size,
                borderColor: `${color} transparent ${color} transparent`,
            }}
        ></div>
    );
};

export default ScoreUnScoreDrive